import styled from 'styled-components'

export const FormContent = styled.div`
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 0 0 4px 4px;
    border-top: none;
    background: #fff;
    gap: 1rem;

    @media (max-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        padding: 15px 10px;
        gap: 0.75rem;
    }
`

export const SectionTitle = styled.div`
    font-size: 20px;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 100%; /* ensure title takes full width */
`

// Optional wrapper for form fields to control width and layout
export const FormFieldWrapper = styled.div`
    flex: 1 1 45%; /* two fields side by side on desktop */
    min-width: 250px;

    @media (max-width: 768px) {
        flex: 1 1 100%; /* full width on mobile */
        min-width: auto;
    }
`

export const DataHandlingWrapper = styled.div`
    margin: 1rem 0;
    font-size: 0.9rem;
    line-height: 1.4;
    padding: 1rem;
    user-select: none;

    a {
        color: #ba9d31;
        text-decoration: underline;
        &:hover {
            text-decoration: none;
            color: #a28729;
        }
    }

    /* Override PrimeReact checkbox colors inside this wrapper */
    .p-checkbox-box {
        border-color: #ba9d31;
    }
    .p-checkbox-box.p-highlight {
        background-color: #ba9d31;
        border-color: #ba9d31;
    }
    .p-checkbox-box.p-focus {
        box-shadow: 0 0 0 0.2rem rgba(186, 157, 49, 0.5);
    }
`

export const Label = styled.label`
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
`

export const Text = styled.span`
    flex: 1;
`
